export enum Rating {
  POSITIVE = 1,
  NEGATIVE = -1,
  RESET = null as any,
}

export interface IMessage {
  id?: string;
  role: 'user' | 'assistant' | 'tool';
  agentName?: string;
  content: string;
  // for the ui to render more pretty
  tempMarkdownFixContent?: string;
  hint?: string;
  context?: IMessageContext[];
  subsetReferences?: ISubset[];
  rating?: Rating;
  showHumanAssistanceMessage?: boolean;
  humanAssistanceRequested?: boolean;
  messageInProgress?: boolean;
  // for tool usage messages
  toolName?: string;
  toolCallId?: string; // Unique ID for this specific tool call
  timestamp?: string;
  toolStatus?: 'running' | 'completed'; // Status of the tool execution
  data?: any;
  files?: Array<{
    originalname: string;
    mimetype: string;
    size: number;
  }>;
}

export interface IMessageContext {
  chunk?: string;
  plainUrl: string;
  s3Url?: string;
  sourceString: string;
  page?: number;
  tags?: string[];
  docType?: string;
  metadata?: any;
  subsetReferences?: string[];
  renderInMessage?: boolean;
  score?: number;
  ingest_entry_id?: string;
  source?: string;
  refNumber?: number; // Reference number for inline citations [1], [2], etc.
  references?: Array<{
    name: string;
    url: string;
    docType?: string;
  }>;
  /** True when this context stands in for an anonymised ingest entry: label-only,
   *  never clickable, no metadata, no chunk text. */
  anonymous?: boolean;
}

export interface ISubset {
  text: string;
  value: string | string[];
  persona?: string;
  functions?: string | string[];
}

// TODO: move to common interfaces
/**
 * Update to the message the agent is sending to the user.
 */
export interface IQueryResponseMessageUpdate {
  type: 'message';
  message: string;
  messageType?: string;
  messageId?: string;
}

/**
* Update to the actions the agent is taking.
* e.g. doing an sql-search, asking for more information, etc.
*/
export interface IQueryResponseActionUpdate {
  type: 'action';
  action: string;
  actionInfo?: any;
}

/**
* Update to the tool usage (function calling)
*/
export interface IQueryResponseToolUsageUpdate {
  type: 'tool_usage';
  timestamp: string;
  toolName: string;
  toolCallId: string; // Unique ID for this specific tool call
  agentId: string;
  agentName: string;
}

/**
* Update when a tool execution is complete
*/
export interface IQueryResponseToolCompleteUpdate {
  type: 'tool_complete';
  timestamp: string;
  toolName: string;
  toolCallId: string; // Unique ID to match with the tool_usage event
  agentId: string;
  agentName: string;
}

/**
* Update to the metadata of the conversation.
* e.g. messageId, conversationId, etc.
*/
export interface IQueryResponseMetaUpdate {
  type: 'meta';
  metaType: string;
  metadata: any;
}

export type IQueryResponseUpdate = IQueryResponseMessageUpdate | IQueryResponseActionUpdate | IQueryResponseToolUsageUpdate | IQueryResponseToolCompleteUpdate | IQueryResponseMetaUpdate;
